var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 61.754,
    height: 68.463,
    viewBox: "0 0 61.754 68.463",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_391",
    "data-name": "Grupo 391",
    transform: "translate(-48.163 -411.537)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_389",
    "data-name": "Grupo 389"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_8292",
    "data-name": "Trazado 8292",
    d: "M79.04,446.76a17.612,17.612,0,1,1,17.611-17.612A17.631,17.631,0,0,1,79.04,446.76Zm0-33.165a15.553,15.553,0,1,0,15.553,15.553A15.571,15.571,0,0,0,79.04,413.6Z",
    fill: "#a6d66b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_390",
    "data-name": "Grupo 390"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_8293",
    "data-name": "Trazado 8293",
    d: "M109.917,480h-2.059a28.819,28.819,0,1,0-57.637,0H48.163a30.877,30.877,0,1,1,61.754,0Z",
    fill: "#a6d66b"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserGreen);
export default __webpack_public_path__ + "static/media/user-green.90da6740fcf35c9673eee10a80385da2.svg";
export { ForwardRef as ReactComponent };